// @flow
import React from "react"
import type { HOC } from "recompose"
import urls from "data/router/urls"
import withRouter from "hoc/withRouter"
import Button from "components/Button/index"
import { H1, Text } from "componentsStyled/Typography"
import { Container } from "componentsStyled/Layout/Containers"

const NotFoundPage = ({ history }) => (
  <Container center>
    <H1>Sailing uncharted waters?</H1>
    <Text big center>
      This page was not found, never existed or was removed.
    </Text>
    <Button onClick={() => history.push(urls.home)}>Return to homepage</Button>
  </Container>
)

const enhancer: HOC<*, {||}> = withRouter

export default enhancer(NotFoundPage)



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js